import { render, staticRenderFns } from "./addressDetail.vue?vue&type=template&id=d60a3c30&scoped=true&"
import script from "./addressDetail.vue?vue&type=script&lang=js&"
export * from "./addressDetail.vue?vue&type=script&lang=js&"
import style0 from "./addressDetail.vue?vue&type=style&index=0&id=d60a3c30&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60a3c30",
  null
  
)

export default component.exports